import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import * as formActions from 'shared/actions/searchForm';
import { setDataLayer } from 'shared/actions/globals';

// import HEADER from 'shared/constants/seoHeaders';
import SeoTexts from 'shared/components/SeoTexts/SeoTexts';
import NewsBlock from 'desktop/components/NewsBlock/NewsBlock';
// import stoUkr from 'shared/assets/images/STO_Avtoexpert_ukr.jpg';
import { DesktopRightSidebar, DesktopButtonMark } from 'shared/components/BannerAll';
// import BrandsSearch from 'desktop/components/BrandsSearch/BrandsSearch';
import SearchBarV2 from 'desktop/components/SearchBarV2/SearchBarV2';

// import osagoRu from 'shared/assets/images/OSAGO_ru.png';
// import osagoUkr from 'shared/assets/images/OSAGO_ukr.png';
// import stoRu from 'shared/assets/images/STO_Avtoexpert_ru.jpg';

import BrandsList from 'desktop/components/BrandsList/BrandsList';

import NewCars from './components/NewCars/NewCars';
import Insurance from './components/Insurance/Insurance';
import TopAvtosalon from '../../components/TopAvtosalon/TopAvtosalon';
import MakesSidebar from '../../components/MakesSidebar/MakesSidebar';
import SpecialAdverts from './components/SpecialAdverts/SpecialAdverts';
import CarCostEstimate from './components/CarCostEstimate/CarCostEstimate';

import * as s from './Home.css';
// import spec1 from './bezopasnost.jpg';
import SPECIAL from '../../constants/special';

class Home extends React.Component {
  static propTypes = {
    // seoHeader: PropTypes.string.isRequired,
    brands: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        count: PropTypes.number,
      }),
    ).isRequired,
    specialCars: PropTypes.shape({
      vipCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      lowPriceCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      europeCars: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    }).isRequired,
    news: PropTypes.arrayOf(PropTypes.shape()),
    videos: PropTypes.arrayOf(PropTypes.shape()),
    newCars: PropTypes.shape(),
    // isLocalUk: PropTypes.bool.isRequired,

    formData: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    avtoSelectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,

    //
    intl: intlShape.isRequired,
    currentPath: PropTypes.string.isRequired,
    routeLocation: PropTypes.shape(),
  };

  static defaultProps = {
    news: [],
    videos: [],
    newCars: {},
    routeLocation: null,
  };

  // state = {
  //   showSpecialProject: false,
  // };

  // componentDidMount() {
  //   this.showSpecialProject();
  // }

  // showSpecialProject = () => {
  //   this.setState({ showSpecialProject: true });
  // };

  render() {
    const {
      brands,
      specialCars,
      intl,
      news,
      videos,
      newCars,
      routeLocation,
      // seoHeader,
      // isLocalUk,
      currentPath,

      formData,
      formState,
      formVocabulary,
      avtoSelectedActions,
    } = this.props;

    // const specialProjects = [
    //   {
    //     image: spec1,
    //     link: 'https://www.facebook.com/childsafety.ab.ua/',
    //   },
    //   {
    //     image: isLocalUk ? osagoUkr : osagoRu,
    //     link: 'https://polis24.ua/',
    //   },
    //   {
    //     image: isLocalUk ? stoUkr : stoRu,
    //     link: 'https://beststo.com.ua/',
    //   },
    // ];

    const BrandsSearchHeadline = <FormattedMessage id="Продажа автомобилей следующих марок" />;
    // const { showSpecialProject } = this.state;

    // consts for search from.
    const transportType = { slug: 'avto' };
    const page = 'search';
    const isCommercial = false;
    const count = 0;
    const isLoading = false;
    const selectedActions = avtoSelectedActions.selectedActions;

    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.headerRow}>
            <div className={s.leftHeader}>
              <h1 className={s.mainH1}>
                <FormattedMessage id="SEO_HOME_H1" />
              </h1>
              <div className={s.mainSubTitle}>
                <FormattedMessage id="SEO_HOME_SUBTITLE" />
              </div>
            </div>
          </div>
          <div>
            <SearchBarV2
              transportType={transportType}
              count={count}
              selectedActions={selectedActions}
              formState={formState}
              formData={formData}
              formVocabulary={formVocabulary}
              page={page}
              isCommercial={isCommercial}
              isLoading={isLoading}
              redirectAfterClearForm={false}
            />
          </div>
          <div>
            <BrandsList
              makes={brands}
              routeLocation={routeLocation}
              subHeadline={BrandsSearchHeadline}
            />
          </div>
          <div>
            <h2 className={s.mainH2}>
              <FormattedMessage id="Частные объявления о продаже автомобилей на сайте Автобазар" />
            </h2>
          </div>

          <div className={s.flexContainer}>
            <div className={s.leftCol}>
              <SpecialAdverts cars={specialCars} specialLinks={SPECIAL.MAIN} />
              <DesktopButtonMark />
              <CarCostEstimate />
              <Insurance />
              <NewCars location={routeLocation} newCars={newCars} />

              <SeoTexts currentPath={currentPath} />

              {news && news.length > 0 && (
                <NewsBlock
                  columns={2}
                  news={news.slice(0, 2)}
                  title={intl.formatMessage({ id: 'Автожурнал' })}
                  linkToShowAllList={'/zhurnal/'}
                  showAllTitle={intl.formatMessage({ id: 'Смотреть все новости' })}
                  lensEvent={'selectNews'}
                />
              )}
              {videos && videos.length > 0 && (
                <NewsBlock
                  isHomeVideo
                  columns={2}
                  news={videos.slice(0, 2)}
                  title={intl.formatMessage({ id: 'Видео' })}
                  linkToShowAllList={'/zhurnal/video/'}
                  showAllTitle={intl.formatMessage({ id: 'Смотреть все видео' })}
                  lensEvent={'selectVideo'}
                />
              )}

              {/* {showSpecialProject && (
                <div className={s.specialProjects}>
                  <span className={s.h3}>
                    <FormattedMessage id="Спецпроекты" />
                  </span>

                  <div className={s.row}>
                    {specialProjects.map(({ link, image }) => (
                      <a
                        key={link}
                        href={link}
                        className={s.project}
                        rel="noopener noreferrer nofollow"
                        target="_blank"
                      >
                        <img src={image} width="233" height="233" alt="" />
                      </a>
                    ))}
                  </div>
                </div>
              )} */}
            </div>
            {/* <DesktopRightSidebar fixedSecondBanner>
              <React.Fragment>
                <TopAvtosalon />
                <div className={s.makesSidebarInner}>
                  <MakesSidebar />
                </div>
              </React.Fragment>
            </DesktopRightSidebar> */}
            <DesktopRightSidebar>
              <TopAvtosalon />
              <MakesSidebar />
            </DesktopRightSidebar>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formState: state.searchForm.selected,
  formData: state.searchForm.data,
  formVocabulary: state.searchForm.vocabulary,
  count: state.searchForm.data.count,

  locale: state.globals.locale,
  currentPath: state.history && state.history.currentPath,
});

const utilActions = dispatch => ({
  toggle: bindActionCreators(formActions.selectedActions.toggle, dispatch),
  clear: bindActionCreators(formActions.selectedActions.clear),
  clearForm: bindActionCreators(formActions.carSetThunks.clearSelected, dispatch),
});

const mapDispatchToProps = dispatch => ({
  avtoSelectedActions: {
    selectedActions: {
      set: bindActionCreators(
        {
          ...formActions.selectedActions.set,
          ...formActions.carSetThunks,
          ...formActions.setData,
        },
        dispatch,
      ),
      ...utilActions(dispatch),
    },
  },
  // motoSelectedActions: {
  //   selectedActions: {
  //     set: bindActionCreators(
  //       {
  //         ...formActions.selectedActions.set,
  //         ...formActions.motoSetThunks,
  //         ...formActions.setData,
  //       },
  //       dispatch,
  //     ),
  //     ...utilActions(dispatch),
  //   },
  // },
  // commercialSelectedActions: {
  //   selectedActions: {
  //     set: bindActionCreators(
  //       {
  //         ...formActions.selectedActions.set,
  //         ...formActions.commercialSetThunks,
  //         ...formActions.setData,
  //       },
  //       dispatch,
  //     ),
  //     ...utilActions(dispatch),
  //   },
  // },
  setDataLayer,
});

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(injectIntl(Home)),
);



// WEBPACK FOOTER //
// ./src/desktop/routes/home/Home.js